import errorMessages from '../../const/errorMessages';
import ToasterService from '../ToasterService';
import * as _ from 'lodash';
import { IProject } from '../../models/IProject';
import { ICohort } from '../../models/ICohort';
import { Environment } from '../../const/environment';

export function getProjectOptionsByEnvironment(project: IProject, platform: string, environment: Environment, cohorts: ICohort[], selectedCohortId: string) {
    const curCohort = _.find(cohorts, { id: selectedCohortId });
    let options;

    if (curCohort) {
        options = curCohort.options || {};
    } else {
        options = project[`${environment}Options`] || {};
    }

    try {
        if (!_.isEmpty(options)) {
            options = JSON.parse(options);
        }
    } catch (e) {
        ToasterService.showError({ title: errorMessages.incorrectProjectOptions });
        return;
    }

    if (!options[platform]) {
        options[platform] = {};
    }

    return options;
}
